<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<div id="xy" style="width:100%;height:100%;"></div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: [],
				myChart: ''
			}
		},
		mounted() {
			this.$request('/center/home/rightOne').then(res => {
				this.init(res.data.list);
			})
		},
		methods: {
			init(pageData) {
				let that = this
				this.myChart = echarts.init(document.getElementById("xy"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				var datavaule = [10, 50, 54, 45, 84]
				const indicator = [{
						name: '技术创新',
						max: 100,
						nameLocation: 'end'
					},
					{
						name: '企业安全',
						max: 100,
					},
					{
						name: '行业地位',
						max: 100,
					},
					{
						name: '经营稳',
						max: 100,
					},
					{
						name: '经营绩效',
						max: 100,
					},
				]

				var option = {
					// title: {
					//     text: '83.7',
					//     top: 'center',
					//     left: 'center',
					//     textStyle: {
					//         fontSize: 18
					//     }
					// },
					tooltip: {
						show: true,
						trigger: "item"
					},
					radar: {
						center: ["50%", "50%"],
						radius: "50%",
						indicator: indicator,
						axisNameGap: 2,
						splitNumber: 6,

						splitArea: {
							areaStyle: {
								color: ['RGBA(104, 110, 244, 1)', 'RGBA(53, 77, 235, 1)', ].reverse(),
							}
						},
						axisLabel: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: "rgba(255, 255, 255, 0.2)",
								width: 1
							}
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.2)', // 分隔线颜色
								width: 1, // 分隔线线宽
							}
						},
						axisName: {
							color: 'rgba(255, 255, 255, 1)',
							fontSize: 11,
						},

					},

					series: [{
						type: "radar",
						symbol: "none",
						name: '五维雷达',
						lineStyle: {
							normal: {
								color: 'rgba(255, 255, 255, 1.0)',
							},
						},
						areaStyle: {
							normal: { // 单项区域填充样式
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(255, 255, 255, 0.6)'
										},
										{
											offset: 1,
											color: 'rgba(255, 255, 255, 0.6)'
										}
									],
									false
								),
								// 设置扇形的阴影
								shadowBlur: 12,
								shadowColor: 'rgba(76, 189, 255, 0.6)',
								shadowOffsetX: 6,
								shadowOffsetY: 6
							}
						},
						data: [datavaule]
					}]
				};


				this.myChart.setOption(option);

				setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 15000)
			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>